import { useDispatch, useSelector } from "react-redux"
import InputGroup from "react-bootstrap/InputGroup"
import Form from "react-bootstrap/Form"
import { teamStatus } from "state_management"

export default function AssetOverbookingButton() {
  const dispatch = useDispatch()
  const assetOverbooking = useSelector((state) => state.teamStatus.assetOverbooked)

  return (
    <InputGroup>
      <Form.Check
        checked={assetOverbooking}
        type={"checkbox"}
        id={`asset-overbooking-checkbox`}
        onChange={(e) => dispatch(teamStatus.overbooking({ assetOverbooking: e.target.checked }))}
      />
      <div className="Include-today">
        <p>Instrument Overbooking</p>
      </div>
    </InputGroup>
  )
}
